module.exports = __webpack_public_path__ + "img/train2.b94edff8.gif";